import type { GenericAbortSignal } from "axios";
import { createInfiniteQuery } from "react-query-kit";

import type { IInfiniteDoctorsParams, IInfiniteDoctorsResponse } from "./types";

import { axiosClient } from "@/api";
import type { IWithInfinite } from "@api/types.ts";
import { getApi } from "@api/apiPath";

const { key, getPath } = getApi("infinite.getAllDoctors");

type IResponse = IWithInfinite<IInfiniteDoctorsResponse>;
type IVariables = IInfiniteDoctorsParams;

const getAllInfiniteDoctors = async (
  props: IVariables & { cursor: number },
  signal?: GenericAbortSignal,
): Promise<IResponse> => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { no_financial_rules = 0, ...rest } = props;
  const { data } = await axiosClient.get(getPath(), {
    params: { ...rest, no_financial_rules },
    signal,
  });

  return data.data;
};

export const useGetAllInfiniteDoctors = createInfiniteQuery<
  IResponse,
  IVariables
>({
  primaryKey: `infinite_${key}`,
  queryFn: ({ queryKey: [_primaryKey, variables], pageParam, signal }) =>
    getAllInfiniteDoctors({ ...variables, cursor: pageParam }, signal),
  getNextPageParam: (lastPage) => lastPage.nextCursor,
  //   initialPageParam: 1
});
